import{ALGOLIA_LEVEL_TEXT as r}from"../../consts/search-filters.js";import{getAlgoliaHierarchyLevelText as t}from"./get-algolia-hierarchy-level-text.js";const e=(e,o,s=1,i=r)=>`${e}.${o}.${t(s,i)}`;export{e as makeSelectedHierarchyParam};
